module.exports = __webpack_public_path__ + "img/logo25.f84552b7.png";